// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatView__container-efa3ff {
  display: flex;
  flex-direction: column;
  position: relative;
}

.ChatView__content-ade329 {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  border-left: 1px solid transparent;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatView.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,kCAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex: 1;\n  border-left: 1px solid transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ChatView__container-efa3ff`,
	"content": `ChatView__content-ade329`
};
module.exports = ___CSS_LOADER_EXPORT___;
